export const TRADE_EXECUTION_COMMENT_CHANGED = 'TRADE_EXECUTION_COMMENT_CHANGED' as const;
export const TRADE_EXECUTION_NOTIFICATIONS_CHANGED = 'TRADE_EXECUTION_NOTIFICATIONS_CHANGED' as const;
export const TRADES_CONFIRMED_EXECUTION_ONLY_DEAL_ID = 'TRADES_CONFIRMED_EXECUTION_ONLY_DEAL_ID' as const;
